import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterContainer from './RouterContainer';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterContainer />
  </React.StrictMode>
);

